import React from 'react';
import { css } from '@emotion/css';
import { Modal } from 'antd';

import useI18n from 'lib/hooks/useI18n';
import { FieldTypeDetailModalProps } from 'lib/types/field';

const detailRowStyle = css`
  display: flex;
  margin: 8px 0;
`;

const rowLabelStyle = css`
  width: 15%;
`;

const rowContentStyle = css`
  width: 85%;
`;

const FieldTypeDetailModal: React.FC<FieldTypeDetailModalProps> = props => {
  const { t } = useI18n();
  const { visible, onCancel, fieldTypeData } = props;

  return (
    <Modal
      maskClosable={false}
      open={visible}
      title={t('pages.fields.modal.viewFieldType')}
      onOk={onCancel}
      onCancel={onCancel}
    >
      <div className={detailRowStyle}>
        <div className={rowLabelStyle}>{t('global.name')}</div>
        <div className={rowContentStyle}>{fieldTypeData.name}</div>
      </div>
      <div className={detailRowStyle}>
        <div className={rowLabelStyle}>{t('global.address')}</div>
        <div className={rowContentStyle}>
          {fieldTypeData.component && fieldTypeData.component.startsWith('http') ? (
            <a href={fieldTypeData.component} target="_blank" rel="noreferrer">
              {fieldTypeData.component}
            </a>
          ) : (
            <span>{fieldTypeData.component}</span>
          )}
        </div>
      </div>
      <div className={detailRowStyle}>
        <div className={rowLabelStyle}>{t('global.description')}</div>
        <div className={rowContentStyle}>{fieldTypeData.description}</div>
      </div>
    </Modal>
  );
};

export default FieldTypeDetailModal;
